import React, { Component } from 'react'
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import {FaSearch, FaTimesCircle} from 'react-icons/fa'

import {RESERVATION_NOT_FOUND_ERROR, INVALID_RESERVATION_CODE} from '../../strings'

const theme = createMuiTheme({
  palette: {
    primary: {
      main: "#B68500",
    }
  },
});

class ReservationIdInput extends Component {

    render(){
        const {
            reservationId,
            onReservationChange,
            onSearchClick,
            errorMessages,
            disabled
        } = this.props
        return (
            <div>
                <div className="line-header-text">Código de reservación</div>
                <div className="guests-block">
                    <div className="reservation-search-block">
                        <input className="text-input" type="text" value={reservationId} onChange={onReservationChange} disabled={disabled}/>
                    </div>
                    <div className="reservation-search-block">
                        <ThemeProvider theme={theme}>
                            <Button color="primary" variant="contained" onClick={onSearchClick} disabled={disabled}>
                                <FaSearch/>
                            </Button>
                        </ThemeProvider>
                    </div>
                </div>
                <div className="error-message">
                {
                    errorMessages.reservationNotFound ?
                        <div>{RESERVATION_NOT_FOUND_ERROR} <FaTimesCircle className="icon-fail-circle"/></div>
                         : errorMessages.reservationNotValid ?
                            <div>{INVALID_RESERVATION_CODE} <FaTimesCircle className="icon-fail-circle"/></div> :
                            errorMessages.selectedEventIdNotFound ? <div>Seleccione a quien desea visitar<FaTimesCircle className="icon-fail-circle"/></div> :
                            <div>&nbsp;</div>
                }
                </div>
            </div>
        )
    }
}

export default ReservationIdInput
